import { render, staticRenderFns } from "./GiveUp.vue?vue&type=template&id=4ac85d06&scoped=true&"
import script from "./GiveUp.vue?vue&type=script&lang=js&"
export * from "./GiveUp.vue?vue&type=script&lang=js&"
import style0 from "./GiveUp.vue?vue&type=style&index=0&id=4ac85d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac85d06",
  null
  
)

export default component.exports